import { render, staticRenderFns } from "./CompanyScreenerView.vue?vue&type=template&id=628fedde&"
import script from "./CompanyScreenerView.vue?vue&type=script&setup=true&lang=js&"
export * from "./CompanyScreenerView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports